/* eslint-disable @typescript-eslint/no-explicit-any */
enum MenuActionTypes {
  SET_LAYOUT_COLLAPSED = 'menu/setLayoutCollapsed',
}

interface SetLayoutCollapsedMenuActionType {
  type: MenuActionTypes.SET_LAYOUT_COLLAPSED;
  payload: boolean;
}

type MenuAction = SetLayoutCollapsedMenuActionType;

const initialState: MenuState = {
  collapsed: false,
};

export const changeLayoutCollapsed = ({ payload }: { payload: any }) => (dispatch: (args: any) => any): void => {
  dispatch({
    type: MenuActionTypes.SET_LAYOUT_COLLAPSED,
    payload,
  });
};

export default function(state: MenuState = initialState, action: MenuAction): MenuState {
  switch (action.type) {
    case MenuActionTypes.SET_LAYOUT_COLLAPSED:
      return {
        ...state,
        collapsed: action.payload,
      };
    default:
      return state;
  }
}

export interface MenuState {
  collapsed: boolean;
}
